export const DEMO_DURATION_MS = 10 * 60 * 1000;
export const DEMO_PAUSE_MAX_MS = 4 * 60 * 1000;
export const DEMO_EXTENSION_MS = 5 * 60 * 1000;

export const msToMinutes = (ms: number): number => Math.round(ms / 60_000);
